import { parseDomain } from 'helpers/parseDomain';

import {
  Input,
  Inject,
  OnInit,
  Component,
} from 'ng-metadata/core';

import { CartService } from 'services/cart.service';
import { DialogService } from 'services/dialog.service';
import { EcommerceService } from 'services/ecommerce.service';

import cartHtml from './cart.html';
import './cart.scss';

@Component({
  selector: 'gw-portal-checkout-cart',
  template: cartHtml,
})
export class CheckoutCartComponent implements OnInit {
  public cart = (<any>window).GW.cart;
  public laroute = (<any>window).laroute;
  public firstShippingId = null;

  public cartSummary: any = {};
  public state = {
    cta: 'Shop',
    mode: '',
    confirming: false,
  };

  @Input() user;

  constructor(
    @Inject('$filter') private $filter,
    @Inject(CartService) private cartService: CartService,
    @Inject(DialogService) private dialogService: DialogService,
    @Inject(EcommerceService) private ecommerceService: EcommerceService,
  ) {}

  /**
   * Component init hook
   */
  async ngOnInit() {
    this.setupCartSummary();
    this.determineMode();
    this.determineEmptyCartCta();
  }

  /**
   * Group order items by product
   */
  setupCartSummary() {
    if (!this.cart) {
      return {};
    }

    this.cartSummary = this.$filter('groupBy')(this.cart.order, 'travelerId');
  }

  isCartEmpty() {
    return Object.keys(this.cartSummary).length === 0;
  }

  /**
   * Hacky way to determine if cart mode is visas or passports.
   * This eventually needs to be polished up to support other products.
   */
  determineMode() {
    this.state.mode = 'passports';

    const products = Object.values(this.cartSummary);

    this.state.mode = Array.isArray(products[0]) ? products[0][0].type : '';
  }

  determineEmptyCartCta() {
    const parsed = parseDomain(window.location.href);

    switch (parsed.domain) {
      case 'travelvisa':
      case 'rushmytravelvisa':
        this.state.cta = 'Shop Travel Visas';
        break;
      case 'onlineexpeditors':
      case 'passportcenter':
        this.state.cta = 'Shop Passports';
        break;
      case 'passportrenewal':
        this.state.cta = 'Shop For Renewal';
        break;
    }
  }

  /**
   * Get itinerary dates for a product
   * @param productId string
   */
  getItineraryDates(productId: string) {
    const destination: any = Object.values(this.cart.itinerary.destinations)
      .find((dest: any) => dest.productId === productId);

    return destination ? destination.dates : { startDate: null, endDate: null };
  }

  /**
   * Remove entire traveler group
   * @param travelerId
   */
  async removeTraveler(travelerId: string) {
    // Delete product from cart
    this.cartService.removeTraveler(travelerId);

    try {
      await this.cartService.saveCart();
      this.firstShippingId = null;
    } catch (e) {
      throw e;
    }

    // Update summary
    this.setupCartSummary();
  }

  /**
   * Remove single order item from cart
   * @param orderItem
   */
  async deleteOrderItem(orderItem: any) {
    // Delete order item under traveler
    this.cartService.removeOrderItem(orderItem);

    try {
      await this.cartService.saveCart();
      this.firstShippingId = null;
    } catch (e) {
      throw e;
    }

    // Update summary
    this.setupCartSummary();
  }

  /**
   * Update order item with new options
   * @param orderItem
   */
  async updateOrderItem(options) {
    this.cart.options[options.uuid] = options;

    // Cleanup options that are no longer used
    Object.keys(this.cart.options).forEach((opt) => {
      this.cartService.cleanupOptions(opt);
    });

    try {
      await this.cartService.saveCart();
    } catch (e) {
      throw e;
    }

    // Update summary
    this.setupCartSummary();
  }

  /**
   * Shows order total
   */
  showOrderTotal() {
    const total = this.cartService.getOrderTotal();
    return this.$filter('currency')(total);
  }

  /**
   * Confirm cart and continue to billing
   */
  async confirmCart() {
    this.state.confirming = true;

    try {
      await this.cartService.saveCart();
      window.location.assign(this.laroute.route('checkout.account'));
    } catch (e) {
      throw e;
    }
  }

  /**
   * Get the reference to the first product that requires shipping
   */
  isFirstShipping(requireShipping, travelerIndex, productIndex) {
    const itemId = `${travelerIndex}-${productIndex}`;
    if (this.firstShippingId == null && requireShipping) {
      this.firstShippingId = itemId;
    }

    return this.firstShippingId === itemId;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/cart/cart.component.ts